import TechBuilder from './TechBuilder';

export default TechBuilder;
